import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import StoreDashboard from "@/pages/StoreDashboard";
import OrgDashboard from "@/pages/OrgDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import Leaderboard from "@/pages/Leaderboard";
import Help from "@/pages/Help";
import Give from "@/pages/Give";
import NearMe from "@/pages/NearMe";
import ForGroceryStores from "@/pages/ForGroceryStores";
import ForAidOrganizations from "@/pages/ForAidOrganizations";
import About from "@/pages/About";
import Transparency from "@/pages/Transparency";
import { Terms, Privacy } from "@/pages/Legal";

function RoleRedirect() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "grocery_store") return <Navigate to="/store" replace />;
  if (user.role === "aid_organization") return <Navigate to="/organization" replace />;
  return <Navigate to="/admin" replace />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/dashboard" element={<RoleRedirect />} />
            <Route path="/store" element={<ProtectedRoute roles={["grocery_store"]}><StoreDashboard /></ProtectedRoute>} />
            <Route path="/organization" element={<ProtectedRoute roles={["aid_organization"]}><OrgDashboard /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute roles={["admin"]}><AdminDashboard /></ProtectedRoute>} />
            <Route path="/leaderboard" element={<ProtectedRoute><Leaderboard /></ProtectedRoute>} />
            <Route path="/help" element={<Help />} />
            <Route path="/give" element={<Give />} />
            <Route path="/near-me" element={<NearMe />} />
            <Route path="/for-grocery-stores" element={<ForGroceryStores />} />
            <Route path="/for-aid-organizations" element={<ForAidOrganizations />} />
            <Route path="/about" element={<About />} />
            <Route path="/transparency" element={<Transparency />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
